var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoryboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 291.986 291.986",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M274.565,38.095v-23.81h-100V0h-57.143v14.286h-100v23.81h14.286v133.333H17.422v23.81h74.343l-31.243,93.733 l9.033,3.014l32.252-96.748h39.424v95.238h9.524v-95.238h39.424l32.248,96.743l9.033-3.014l-31.238-93.729h74.343v-23.81h-14.286 V38.095H274.565z M126.946,9.524h38.095v4.762h-38.095V9.524z M265.041,180.952v4.762H150.756h-9.524H26.946v-4.762h4.762 h228.571H265.041z M41.232,171.429V38.095h209.524v133.334H41.232z M31.708,28.572h-4.762v-0.001V23.81h90.476h57.143h90.476 v4.762h-4.762H31.708z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.756,161.905h90.476v-52.381H50.756V161.905z M60.279,119.048h71.429v33.333h-0.001H60.279V119.048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.756,161.905h90.476v-52.381h-90.476V161.905z M160.279,119.048h71.429v33.333h-71.429V119.048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.899,47.619H50.756V100h57.143V47.619z M98.375,90.476H60.279V57.143h38.095V90.476z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.565,47.619h-57.143V100h57.143V47.619z M165.04,90.476h-38.095V57.143h38.095V90.476z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.089,100h57.143V47.619h-57.143V100z M193.613,57.143h38.095v33.333h-38.095V57.143z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryboard);
export default __webpack_public_path__ + "static/media/storyboard.a8b062c34473c8b942f8241b564ebe0f.svg";
export { ForwardRef as ReactComponent };